import { formatRelative } from '@/lib/time';
import { cn } from '@/lib/cn';

export type ActivityEvent = {
  id: string;
  type: string;
  title: string;
  timestamp: string;
  severity: 'info' | 'success' | 'warning' | 'danger';
  href?: string;
};

const dotColor: Record<ActivityEvent['severity'], string> = {
  info: 'bg-primary', success: 'bg-success', warning: 'bg-warning', danger: 'bg-danger',
};

export function ActivityFeedItem({ event }: { event: ActivityEvent }) {
  const Body = (
    <div className="flex items-center gap-2.5 border-b border-divider py-1.5 last:border-b-0">
      <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', dotColor[event.severity])} />
      <span className="flex-1 truncate text-[12px] text-text">{event.title}</span>
      <span className="shrink-0 text-[11px] text-muted">{formatRelative(event.timestamp)}</span>
    </div>
  );
  return event.href ? <a href={event.href} className="block hover:bg-bg/50">{Body}</a> : Body;
}
